<div class="dtf-accountdetails admin-incidents-page">
  <div class="dashboard-loading-overlay" *ngIf="isDashboardLoading" aria-live="polite" aria-busy="true">
    <div class="dashboard-loading-content">
      <span class="dashboard-loading-spinner" aria-hidden="true"></span>
      <p>Loading dashboard data...</p>
    </div>
  </div>

  <div class="incident-form-loader-overlay" *ngIf="isOpeningIncidentForm">
    <div class="incident-form-loader-content">
      <span class="incident-form-spinner" aria-hidden="true"></span>
      <p>Opening incident form...</p>
    </div>
  </div>

  <div class="dtf-alertpage"></div>

  <div class="container_dashboard">
    <div class="cardlike incidents-header-card">
      <div class="incidents-header-row">
        <h1 class="mercedes-me-login__column-headline2">Incident Management Dashboard</h1>
        <div class="incident-raise-action">
          <button class="mbfs-button incident-raise-btn" (click)="raiseIncident()" [disabled]="isNavigatingToDashboard">
            <span *ngIf="isNavigatingToDashboard" class="incident-raise-btn-spinner" aria-hidden="true"></span>
            {{ isNavigatingToDashboard ? 'Redirecting...' : 'Raise Incident' }}
          </button>
          <small class="incident-raise-disclaimer">To raise a new incident ticket, go to the User Management tile.</small>
        </div>
      </div>
      <p class="paragraph1">Track incident trends and review all open and in-progress issues.</p>
    </div>

    <div class="row kpi-row">
      <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
        <div class="card kpi-card">
          <p class="kpi-label">Total Incidents</p>
          <p class="kpi-value">{{ totalIncidents }}</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
        <div class="card kpi-card">
          <p class="kpi-label">Open</p>
          <p class="kpi-value">{{ openIncidents }}</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
        <div class="card kpi-card">
          <p class="kpi-label">In Progress</p>
          <p class="kpi-value">{{ inProgressIncidents }}</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
        <div class="card kpi-card">
          <p class="kpi-label">Closed</p>
          <p class="kpi-value">{{ closedIncidents }}</p>
        </div>
      </div>
    </div>

    <div class="row chart-row g-3">
      <div class="col-lg-6 col-md-6 col-sm-12 mb-3 chart-col">
        <div class="card chart-card">
          <h2 class="chart-title">Incident Status</h2>
          <canvas id="statusChart"></canvas>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 mb-3 chart-col">
        <div class="card chart-card">
          <h2 class="chart-title">Monthly Incidents</h2>
          <canvas id="monthlyChart"></canvas>
        </div>
      </div>
    </div>
    <br>

    <mat-table [dataSource]="incidentDataSource" class="mat-elevation-z8 incident-mat-table">
      <ng-container matColumnDef="incidentID">
        <mat-header-cell mat-header-cell *matHeaderCellDef style="justify-content: center;">Incident ID</mat-header-cell>
        <mat-cell *matCellDef="let incident" style="justify-content: center;">
          <a href="javascript:void(0)" (click)="openIncidentPopup(incident)">{{ incident.incidentID }}</a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="agentID">
        <mat-header-cell mat-header-cell *matHeaderCellDef style="justify-content: center;">Agent ID</mat-header-cell>
        <mat-cell *matCellDef="let incident" style="justify-content: center;">
          <span class="agent-id-text">{{ incident.agentID }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="pageName">
        <mat-header-cell mat-header-cell *matHeaderCellDef style="justify-content: center;">Page</mat-header-cell>
        <mat-cell *matCellDef="let incident" style="justify-content: center;">{{ incident.pageName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="country">
        <mat-header-cell mat-header-cell *matHeaderCellDef style="justify-content: center;">Country</mat-header-cell>
        <mat-cell *matCellDef="let incident" style="justify-content: center;">{{ incident.country }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="title">
        <mat-header-cell mat-header-cell *matHeaderCellDef style="justify-content: center;">Title</mat-header-cell>
        <mat-cell *matCellDef="let incident" style="justify-content: center;">{{ incident.title }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="screenshots">
        <mat-header-cell mat-header-cell *matHeaderCellDef style="justify-content: center;">Screenshots</mat-header-cell>
        <mat-cell *matCellDef="let incident" style="justify-content: center;">
          <div class="table-screenshot-list" *ngIf="(incident.screenshots || []).length; else noScreenshot">
            <div class="table-screenshot-item" *ngFor="let screenshot of incident.screenshots">
              <img
                *ngIf="screenshot.previewUrl"
                [src]="screenshot.previewUrl"
                alt="Incident Screenshot"
                class="table-screenshot-thumb"
                (click)="openScreenshot(screenshot.previewUrl)"
              >
              <button
                type="button"
                class="screenshot-action"
                (click)="downloadScreenshot(screenshot)"
                [disabled]="!screenshot.previewUrl && !screenshot.base64"
              >
                Download
              </button>
              <span class="screenshot-name" *ngIf="screenshot.name">{{ screenshot.name }}</span>
            </div>
          </div>
          <div class="table-screenshot-name-list" *ngIf="!(incident.screenshots || []).length && getScreenshotNames(incident).length">
            <span class="screenshot-name" *ngFor="let screenshotName of getScreenshotNames(incident)">{{ screenshotName }}</span>
          </div>
          <ng-template #noScreenshot>
            <span class="screenshot-empty">-</span>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell mat-header-cell *matHeaderCellDef style="justify-content: center;">Status</mat-header-cell>
        <mat-cell *matCellDef="let incident" style="justify-content: center;">
          <span class="status-badge" [ngClass]="{
            'status-open': incident.status === 'Open',
            'status-progress': incident.status === 'In Progress',
            'status-closed': incident.status === 'Closed',
            'status-cancel': incident.status === 'Cancel'
          }">
            {{ incident.status }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <mat-header-cell mat-header-cell *matHeaderCellDef style="justify-content: center;">Created Date</mat-header-cell>
        <mat-cell *matCellDef="let incident" style="justify-content: center;">{{ incident.createdDate }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="updatedDate">
        <mat-header-cell mat-header-cell *matHeaderCellDef style="justify-content: center;">Updated Date</mat-header-cell>
        <mat-cell *matCellDef="let incident" style="justify-content: center;">{{ incident.updatedDate }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let incident; columns: displayedColumns"></mat-row>
    </mat-table>

    <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
    <br><br>

    <div class="incident-popup-overlay" *ngIf="showIncidentPopup">
      <div class="incident-popup" role="dialog" aria-modal="true" aria-label="Incident details">
        <div class="incident-popup-header">
          <h2 class="mercedes-me-login__column-headline2">{{ popupMode === 'create' ? 'Raise Incident' : 'Incident Details' }}</h2>
          <button type="button" class="popup-close" (click)="closeIncidentPopup()">x</button>
        </div>

        <div class="incident-popup-body">
          <div class="popup-field-grid">
            <div class="popup-field">
              <label>Username of affected Customer <span *ngIf="popupMode === 'create'" class="required-mark">*</span></label>
              <input type="text" [(ngModel)]="incidentForm.usernameOfAffectedCustomer" [readonly]="popupMode === 'edit'">
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && !incidentForm.usernameOfAffectedCustomer.trim()">This field is required.</small>
            </div>

            <div class="popup-field">
              <label>Account Number <span *ngIf="popupMode === 'create'" class="required-mark">*</span></label>
              <div class="account-search-row" *ngIf="popupMode === 'create' && accountNumberOptions.length > 0">
                <input
                  type="text"
                  [(ngModel)]="accountNumberSearchTerm"
                  (input)="searchAccountNumbers()"
                  (keyup.enter)="searchAccountNumbers()"
                  placeholder="Search account number"
                  [disabled]="isLoadingAccountNumbers"
                >
                <button type="button" class="screenshot-action" (click)="searchAccountNumbers()" [disabled]="isLoadingAccountNumbers">Search</button>
              </div>
              <select *ngIf="popupMode === 'create' && accountNumberOptions.length > 0" [(ngModel)]="incidentForm.accountNumber" (ngModelChange)="onAccountNumberSelectionChange()" [disabled]="isLoadingAccountNumbers">
                <option value="">{{ isLoadingAccountNumbers ? 'Loading account numbers...' : 'Select account number' }}</option>
                <option *ngFor="let accountNumberOption of filteredAccountNumberOptions" [value]="accountNumberOption.accountNumber">{{ accountNumberOption.accountNumber }}</option>
              </select>
              <input *ngIf="popupMode === 'edit' || accountNumberOptions.length === 0" type="text" [(ngModel)]="incidentForm.accountNumber" [readonly]="popupMode === 'edit'">
              <small class="field-help" *ngIf="popupMode === 'create' && accountNumberOptions.length > 0 && filteredAccountNumberOptions.length === 0">No account numbers match your search.</small>
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && !incidentForm.accountNumber.trim()">This field is required.</small>
            </div>

            <div class="popup-field">
              <label>Third Party <span *ngIf="popupMode === 'create'" class="required-mark">*</span></label>
              <input type="text" [(ngModel)]="incidentForm.thirdParty" readonly>
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && !incidentForm.thirdParty.trim()">This field is required.</small>
            </div>

            <div class="popup-field">
              <label>Agent Name / Short ID <span *ngIf="popupMode === 'create'" class="required-mark">*</span></label>
              <input type="text" [(ngModel)]="incidentForm.agentNameShortId" [readonly]="popupMode === 'edit'">
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && !incidentForm.agentNameShortId.trim()">This field is required.</small>
            </div>

            <div class="popup-field">
              <label>Website Page (Screen) <span *ngIf="popupMode === 'create'" class="required-mark">*</span></label>
              <select [(ngModel)]="incidentForm.websitePageScreen" (ngModelChange)="onWebsitePageSelectionChange()" [disabled]="popupMode === 'edit'">
                <option value="">Select page</option>
                <option *ngFor="let pageOption of websitePageOptions" [value]="pageOption">{{ pageOption }}</option>
              </select>
              <input
                *ngIf="incidentForm.websitePageScreen === 'Other'"
                type="text"
                [(ngModel)]="incidentForm.otherWebsitePage"
                [readonly]="popupMode === 'edit'"
                placeholder="Enter page name"
              >
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && !incidentForm.websitePageScreen.trim()">This field is required.</small>
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && incidentForm.websitePageScreen === 'Other' && !incidentForm.otherWebsitePage.trim()">Please enter the page name.</small>
            </div>

            <div class="popup-field">
              <label>Country <span *ngIf="popupMode === 'create'" class="required-mark">*</span></label>
              <select [(ngModel)]="incidentForm.country" [disabled]="popupMode === 'edit'">
                <option value="">Select country</option>
                <option *ngFor="let countryOption of countryOptions" [value]="countryOption.value">{{ countryOption.label }}</option>
              </select>
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && !incidentForm.country.trim()">This field is required.</small>
            </div>

            <div class="popup-field">
              <label>Incident Title <span *ngIf="popupMode === 'create'" class="required-mark">*</span></label>
              <input type="text" [(ngModel)]="incidentForm.incidentTitle" [readonly]="popupMode === 'edit'">
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && !incidentForm.incidentTitle.trim()">This field is required.</small>
            </div>

            <div class="popup-field popup-field-full">
              <label>
                Detailed Description <span *ngIf="popupMode === 'create'" class="required-mark">*</span>
                <span class="field-help" *ngIf="incidentForm.websitePageScreen === 'Payment Log Queries'">
                  For payment log queries, please include the payment amount, transaction or confirmation ID, and the date and time of payment. These details are essential to locate and investigate the relevant payment logs.
                </span>
              </label>
              <textarea rows="3" [(ngModel)]="incidentForm.detailedDescription" [readonly]="popupMode === 'edit'"></textarea>
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && !incidentForm.detailedDescription.trim()">This field is required.</small>
            </div>

            <div class="popup-field">
              <label>Screenshot Attachment <span *ngIf="popupMode === 'create' && isScreenshotRequired" class="required-mark">*</span><span *ngIf="!isScreenshotRequired" class="field-help"> (Optional)</span></label>
              <input *ngIf="popupMode === 'create'" type="file" accept="image/*" multiple (change)="onScreenshotFilesSelected($event)">
              <input *ngIf="popupMode === 'edit'" type="text" [value]="incidentForm.screenshotAttachmentNames.join(', ')" readonly>
              <div class="popup-screenshot-list" *ngIf="incidentForm.screenshotAttachments.length">
                <div class="popup-screenshot-item" *ngFor="let screenshot of incidentForm.screenshotAttachments">
                  <img
                    *ngIf="screenshot.previewUrl"
                    [src]="screenshot.previewUrl"
                    alt="Incident Screenshot"
                    class="popup-screenshot-thumb"
                    (click)="openScreenshot(screenshot.previewUrl)"
                  >
                  <button
                    type="button"
                    class="screenshot-action"
                    (click)="downloadScreenshot(screenshot)"
                    [disabled]="!screenshot.previewUrl && !screenshot.base64"
                  >
                    Download
                  </button>
                  <span class="screenshot-name" *ngIf="screenshot.name">{{ screenshot.name }}</span>
                </div>
              </div>
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && isScreenshotRequired && incidentForm.screenshotAttachmentNames.length === 0">At least one image is required.</small>
              <small class="field-error" *ngIf="screenshotValidationError">{{ screenshotValidationError }}</small>
              <small class="field-help" *ngIf="incidentForm.screenshotAttachmentNames.length > 0">Selected: {{ incidentForm.screenshotAttachmentNames.join(', ') }}</small>
            </div>

            <div class="popup-field">
              <label>Customers Impacted <span *ngIf="popupMode === 'create'" class="required-mark">*</span></label>
              <input type="number" min="1" [(ngModel)]="incidentForm.customersImpacted" [readonly]="popupMode === 'edit'">
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && !incidentForm.customersImpacted.toString().trim()">This field is required.</small>
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && +incidentForm.customersImpacted <= 0">Enter a value greater than 0.</small>
            </div>

            <div class="popup-field popup-field-full">
              <label>Additional Comments</label>
              <textarea rows="2" [(ngModel)]="incidentForm.additionalComments"></textarea>
            </div>

            <div class="popup-field" *ngIf="popupMode === 'edit'">
              <label>Status</label>
              <select [(ngModel)]="incidentForm.status">
                <option *ngFor="let statusOption of statusOptions" [value]="statusOption">{{ statusOption }}</option>
              </select>
            </div>

            <div class="popup-field popup-field-full" *ngIf="popupMode === 'edit'">
              <label>Developer Resolution</label>
              <textarea rows="2" [(ngModel)]="incidentForm.developerResolution"></textarea>
              <small class="field-error" *ngIf="popupMode === 'edit' && showFormErrors && incidentForm.status === 'Closed' && !incidentForm.developerResolution.trim()">Developer Resolution is required when status is Closed.</small>
            </div>

            <div class="popup-field popup-field-full checkbox-field">
              <label>
                <input type="checkbox" [(ngModel)]="incidentForm.pegaVerificationCompleted" [disabled]="popupMode === 'edit'">
                <a [href]="pegaLoginUrl" target="_blank" rel="noopener noreferrer">PEGA</a> Customer View Verification Completed <span *ngIf="popupMode === 'create'" class="required-mark">*</span>
              </label>
              <small class="field-error" *ngIf="popupMode === 'create' && showFormErrors && !incidentForm.pegaVerificationCompleted">Please confirm PEGA verification.</small>
            </div>
          </div>
        </div>

        <div class="incident-popup-footer">
          <button type="button" class="mbfs-button secondary-btn" (click)="closeIncidentPopup()">Cancel</button>
          <button
            type="button"
            class="mbfs-button incident-submit-btn"
            (click)="saveIncidentEdits()"
            [disabled]="(popupMode === 'create' && isCreatingIncident) || (popupMode === 'edit' && isUpdatingIncident)"
          >
            <span *ngIf="(popupMode === 'create' && isCreatingIncident) || (popupMode === 'edit' && isUpdatingIncident)" class="incident-submit-spinner" aria-hidden="true"></span>
            {{ popupMode === 'create' ? (isCreatingIncident ? 'Submitting...' : 'Raise Incident') : (isUpdatingIncident ? 'Saving...' : 'Save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>